(() => {
  'use strict';
  function init() {
    document.querySelectorAll('[data-mx-scenes]').forEach(region => {
      if (region.dataset.mxBound) return;
      region.dataset.mxBound = 'true';
      const next = region.querySelector('.mx-scene-next');
      const button = region.querySelector('[data-mx-scenes-toggle]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let stopped = motion.matches, visible = false, hovered = false, focused = false, timer;
      const sync = () => {
        clearInterval(timer);
        if (visible && !document.hidden && !stopped && !hovered && !focused) timer = setInterval(() => next.classList.toggle('mx-scene-active'), 5500);
        button.textContent = stopped ? '▶' : 'Ⅱ';
        button.setAttribute('aria-label', stopped ? 'Play collection images' : 'Pause collection images');
      };
      const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;sync();});
      observer.observe(region);
      button.addEventListener('click', () => {stopped=!stopped;sync();});
      region.addEventListener('pointerenter', () => {hovered=true;sync();});
      region.addEventListener('pointerleave', () => {hovered=false;sync();});
      region.addEventListener('focusin', () => {focused=true;sync();});
      region.addEventListener('focusout', event => {if(!region.contains(event.relatedTarget)){focused=false;sync();}});
      const preference = () => {stopped=motion.matches;sync();};
      motion.addEventListener('change',preference);
      document.addEventListener('visibilitychange',sync);
      region.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {observer.disconnect();clearInterval(timer);document.removeEventListener('visibilitychange',sync);motion.removeEventListener('change',preference);}, {once:true});
      sync();
    });
    document.querySelectorAll('.mx-ref-highlights').forEach(section => {
      if (section.dataset.mxBound) return;
      section.dataset.mxBound = 'true';
      const track = section.querySelector('[data-mx-track]');
      const buttons = section.querySelectorAll('[data-mx-slide]');
      if (!track) return;
      const update = () => buttons.forEach(button => {
        button.disabled = Number(button.dataset.mxSlide) < 0 ? track.scrollLeft <= 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      });
      buttons.forEach(button => button.addEventListener('click', () => track.scrollBy({left: Number(button.dataset.mxSlide) * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'})));
      track.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);
      update();
    });
    document.querySelectorAll('[data-mx-video-region]').forEach(region => {
      if (region.dataset.mxBound) return;
      region.dataset.mxBound = 'true';
      const video = region.querySelector('video');
      const button = region.querySelector('[data-mx-video-toggle]');
      if (!video) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      // On data-saver or 2G connections keep the poster; visitors can still press play.
      const conn = navigator.connection;
      const lowData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
      let visible = false, stopped = motion.matches || lowData;
      video.autoplay = false;
      video.pause();
      const update = () => {if (button) {button.textContent = video.paused ? '▶' : 'Ⅱ';button.setAttribute('aria-label',video.paused ? 'Play brand film' : 'Pause brand film');}};
      const sync = () => {
        if (visible && !document.hidden && !stopped) {
          const source = video.querySelector('source[data-src]');
          if (source) {source.src = source.dataset.src; source.removeAttribute('data-src'); video.load();}
          video.play().catch(update);
        } else video.pause();
      };
      const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting; sync();}, {threshold:0.1});
      observer.observe(region);
      const preference = () => {stopped = motion.matches || lowData; sync();};
      motion.addEventListener('change', preference);
      document.addEventListener('visibilitychange', sync);
      if (button) button.addEventListener('click', () => {stopped = !video.paused; sync();});
      video.addEventListener('play', update);video.addEventListener('pause', update);update();
      region.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {observer.disconnect();video.pause();document.removeEventListener('visibilitychange',sync);motion.removeEventListener('change',preference);}, {once:true});
    });
    document.querySelectorAll('[data-mx-pillars]').forEach(region => {
      if (region.dataset.mxBound) return;
      region.dataset.mxBound = 'true';
      const track = region.querySelector('[data-mx-pillar-track]');
      const button = region.querySelector('[data-mx-pillar-toggle]');
      const originals = Array.from(track.children);
      originals.forEach(card => {const copy = card.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.setAttribute('tabindex','-1');copy.inert = true;track.appendChild(copy);});
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let stopped = motion.matches, visible = false, hover = false, focused = false, frame = 0, last = 0, position = track.scrollLeft;
      const update = () => {button.textContent = stopped ? '▶' : 'Ⅱ';button.setAttribute('aria-label',stopped ? 'Play brand cards' : 'Pause brand cards');};
      const tick = time => {
        const distance = track.children[originals.length].offsetLeft - originals[0].offsetLeft;
        if (last && distance > 0) {position += Math.min(time-last,64)*0.022; if(position >= distance) position -= distance; track.scrollLeft = position;}
        last = time; frame = requestAnimationFrame(tick);
      };
      const sync = () => {cancelAnimationFrame(frame);last=0;position=track.scrollLeft;if(visible && !document.hidden && !stopped && !hover && !focused)frame=requestAnimationFrame(tick);update();};
      const observer = new IntersectionObserver(entries => {visible=entries[0].isIntersecting;sync();});
      observer.observe(region);
      button.addEventListener('click', () => {stopped=!stopped;sync();});
      track.addEventListener('pointerenter', () => {hover=true;sync();});
      track.addEventListener('pointerleave', () => {hover=false;sync();});
      track.addEventListener('pointerdown', () => {stopped=true;sync();});
      track.addEventListener('focusin', () => {focused=true;sync();});
      track.addEventListener('focusout', event => {if(!track.contains(event.relatedTarget)){focused=false;sync();}});
      const preference = () => {stopped=motion.matches;sync();};
      motion.addEventListener('change',preference);
      document.addEventListener('visibilitychange',sync);
      region.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {observer.disconnect();cancelAnimationFrame(frame);document.removeEventListener('visibilitychange',sync);motion.removeEventListener('change',preference);}, {once:true});
      update();
    });
  }
  init();document.addEventListener('shopify:section:load', init);
})();
